export const IS_PROD = import.meta.env.MODE === "production";
export const IS_DEV  = import.meta.env.MODE === "development";